import { render, staticRenderFns } from "./contentCourseLearnerDeleteHisExam.vue?vue&type=template&id=322fb5cd&"
import script from "./contentCourseLearnerDeleteHisExam.vue?vue&type=script&lang=js&"
export * from "./contentCourseLearnerDeleteHisExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports